"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _productActivation = require("ui-addon-upgrades/_core/common/constants/productActivation");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _connectedUpgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/connectedUpgradeDataPropsInterface");

var ProductActivationWrapper = function ProductActivationWrapper(WrappedComponent) {
  var ProductActivationWrapperHOC = function ProductActivationWrapperHOC(props) {
    var upgradeProduct = props.upgradeData.upgradeProduct;
    var isProductActivationWrapperProduct = _productActivation.productActivationProducts.indexOf(upgradeProduct) !== -1;

    if (!isProductActivationWrapperProduct) {
      _devLogger.default.warn({
        message: "ProductActivationWrapper: Expected upgradeProduct to be one of " + _productActivation.productActivationProducts,
        key: "ProductActivationWrapper"
      });

      return null;
    }

    return _react.default.createElement(WrappedComponent, props);
  };

  ProductActivationWrapperHOC.propTypes = _connectedUpgradeDataPropsInterface.connectedUpgradeDataPropsInterface;
  return ProductActivationWrapperHOC;
};

var _default = ProductActivationWrapper;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/ProductActivationWrapper.js
// module id = 769
// module chunks = 5 6